module.exports = __webpack_public_path__ + "static/media/plus-light-blue.cebbe6e4.svg";